<template>
    <div class="row">

        <div v-for="(val, index) in list" :key="index" :class="{'col-md-6': (index < 2), 'col-md-3': (index >= 2), 'last-col-device': (index == 3), 'hidden-device': (index > 3)}" class="col col-xs-12">
            <div class="thumbnail" :class="{'large': (index < 2), 'fullwidth': (index == 0), 'alignment': (index != 0)}">
                <div class="wrap">
                    <div class="image">
                        <a :href="val.url"><img v-lazy="val.thumbnail" :data-srcset="val.thumbnailx2 + ' 2x'" :srcset="val.thumbnailx2 + ' 2x'" :alt="val.title"></a>
                        <div class="label-box" v-if="val.is_sponsor"><span class="label label-sponsored">Sponsored</span></div>
                    </div>
                    <div class="meta">
                        <div class="pick-box" v-if="val.is_editorpick || val.is_newly">
                            <span pickbox-rotate class="pick-anim" :class="( val.is_editorpick ? 'editor' : 'newly') + '-active'">
                                <a class="pick editor" href="#" v-if="val.is_editorpick"><i class="ic ic-heart"></i><span class="ic-name">Editor's Pick</span></a>
                                <a class="pick newly" href="#" v-if="val.is_newly" ><i class="ic ic-newly"></i><span class="ic-name">Newly Opened</span></a>
                            </span>
                        </div>
                        <h3 class="title"><a :href="val.url">{{ val.title }}</a></h3>
                        <div class="info" v-html="val.loc"></div>
                        <div class="category" v-html="val.dptag"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import config from '@/../myconfig.js'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)

const myConfig = config

export default {
  name: 'InstagramHome',
  mounted () {

  },
  data: function () {
    return {
      list: window._werec,
      THEME_PATH: myConfig.THEME_PATH
    }
  }
}
</script>
